export default __webpack_public_path__ + "static/media/bell.4f6a7350.svg";